<template>
  <a-modal v-model="visible" :title="`${form.id ? $t('编辑用户信息') : $t('新增用户信息')}`" :width="1000">
    <div slot="footer">
      <a-button @click="visible = false">{{ $t('取消') }}</a-button>
      <a-button :loading="loading" type="primary" @click="handleCommit">{{ $t('保存') }}</a-button>
    </div>
    <a-form-model ref="form" :model="form" :rules="rules" :labelCol="{ span: 4 }" :wrapperCol="{ span: 18 }">
      <a-row>
        <a-col :span="24">
          <a-form-model-item :label="$t('姓名')" prop="userName">
            <a-input v-model="form.userName" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('登录名')" prop="loginName">
            <a-input v-model="form.loginName" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('所属应用')" prop="appId">
            <a-select v-model="form.appId" :options="appIdOptions" allowClear :disabled="form.id != null" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>
<script>
import { saveUser } from '@/api/user/user'
import { getAppListForCurrentUser } from '@/api/app/app'

export default {
  data() {
    return {
      visible: false,
      form: {},
      loading: false,
      appIdOptions: [],
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.user
    },
    rules() {
      const result = {
        name: [{ required: true, message: this.$t('请输入') }],
        loginName: [{ required: true, message: this.$t('请输入') }],
      }
      return result
    }
  },
  created() {
    this.loadOptions()
  },
  methods: {
    loadOptions() {
      getAppListForCurrentUser().then(res => {
        if (res.code === 0) {
          this.appIdOptions = res.data.map(e => ({
            label: e.name,
            value: e.id
          }))
        }
      })
    },
    show(data) {
      this.form = { ...data }
      this.visible = true
    },
    handleCommit() {
      this.$refs.form.validate((success) => {
        if (!success) {
          return
        }
        this.loading = true
        const commitData = {
          ...this.form,
        }
        saveUser(commitData).then(res => {
          if (res.code === 0) {
            this.$message.success(this.$t('保存成功'))
            this.$emit('ok', this.form)
            this.visible = false
          } else {
            this.$message.error(res.message || this.$t('保存失败'))
          }
        }).catch(err => {
          this.$message.error(this.$t('保存失败'))
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>